import { combineReducers } from 'redux'
import * as t from './actionTypes'
import { setterReducer } from '../common/redux'

const token = setterReducer(null, t.SET_VISIT_TOKEN)
const visit = combineReducers({ token })

export { visit as default }


// WEBPACK FOOTER //
// ./assets/interview/visit.js